import React, { createContext, Suspense, useMemo, useRef } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Drawer from 'new/components/drawer/Drawer';
import PrivateRoute from 'js/components/route_utils/PrivateRoute';
import { router } from 'new/routes/router';
import styles from './Marketplace.module.scss';
import { useIsOrgFeatureEnabled } from 'new/hooks/adapters/useIsOrgFeatureEnabled';
import { EnableMarketplace } from './EnableMarketplace/EnableMarketplace';
import structure from 'new/routes/structure';
import {
  ROUTE_DATA_PRODUCTS,
  ROUTE_ENABLE_MARKETPLACE,
  ROUTE_MARKETPLACE,
} from 'new/constants/pathnames';
import RouteLoadingComponent from 'js/components/route_utils/RouteLoadingComponent';
import { useSectionNavigation, useLastVisitedPath } from 'new/hooks/useSectionNavigation';

export const MarketplaceContext = createContext({
  containerRef: { current: null },
});

export default function Marketplace() {
  const containerRef = useRef();
  useSectionNavigation('marketplace');

  const contextValue = useMemo(() => {
    return { containerRef };
  }, []);
  const isMarketplaceEnabled = useIsOrgFeatureEnabled('marketplace');

  const SIDEBAR_GROUPS = structure
    .find((s) => s.name === 'Marketplace')
    .groups(!isMarketplaceEnabled);

  const filteredRoutes = router.manager
    .getRoutes('marketplace')
    .filter((route) => route.name !== 'EnableMarketplace');

  const defaultPath = isMarketplaceEnabled ? ROUTE_DATA_PRODUCTS : ROUTE_ENABLE_MARKETPLACE;
  const lastVisitedPath = useLastVisitedPath('marketplace', ROUTE_MARKETPLACE, defaultPath);

  const marketplaceChild = (
    <Drawer content={SIDEBAR_GROUPS as any}>
      <div className={styles.container} ref={containerRef}>
        <MarketplaceContext.Provider value={contextValue}>
          <Switch>
            {isMarketplaceEnabled === true ? (
              filteredRoutes.map((route) => <PrivateRoute key={route.name} {...route} />)
            ) : (
              <PrivateRoute
                key={EnableMarketplace.screenConfig.screenName}
                {...router.manager.getRoute('EnableMarketplace', 'marketplace')}
              />
            )}
            <Route path="*">
              {lastVisitedPath ? <Redirect to={lastVisitedPath} /> : <Redirect to={defaultPath} />}
            </Route>
          </Switch>
        </MarketplaceContext.Provider>
      </div>
    </Drawer>
  );

  return <Suspense fallback={<RouteLoadingComponent />}>{marketplaceChild}</Suspense>;
}
